module.exports = "<p>game-vindow works!</p>\r\n"